module.exports = __webpack_public_path__ + "static/media/20210410_212716_522_IMG_0409.ab9fb159.jpg";